import { SearchInput } from '../shared';
import { SortOrder, CustomerSortType } from '../enums';

export class GetCustomerInformationsInput extends SearchInput<CustomerSortType> {
    public projects = Array<number>();
    public cargoIntegrations = Array<number>();
    public erPs = Array<number>();
    public modules = Array<number>();
    public virtualPoses = Array<number>();

    constructor() {
        super(CustomerSortType.Name);
        this.sortOrder = SortOrder.Ascending;
    }
}
